import { render, staticRenderFns } from "./ProductSubCategoryForm.vue?vue&type=template&id=5aab6c96&"
import script from "./ProductSubCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ProductSubCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports